import { createTheme } from "@mui/material/styles";
import { ColorVariables } from "configs";

const GlobalTheme = createTheme({
  components: {
    MuiFilledInput: {
      styleOverrides: {
        root: {
          "&": {
            backgroundColor: "rgba(0, 0, 0, 0.015)", // Default "rgba(0, 0, 0, 0.06)",
          },
          "&:not(.Mui-disabled):hover": {
            backgroundColor: "rgba(0, 0, 0, 0.025)", // Default "rgba(0, 0, 0, 0.09)",
          },
          "&:not(.Mui-disabled).Mui-focused": {
            backgroundColor: "rgba(0, 0, 0, 0.015)", // Default "rgba(0, 0, 0, 0.06)",
          },
          "&.Mui-disabled": {
            backgroundColor: "rgba(0, 0, 0, 0.04)", // Default "rgba(0, 0, 0, 0.12)",
          },
        },
        input: {
          ".MuiSelect-filled&:not(.Mui-disabled):focus": {
            backgroundColor: "rgba(0, 0, 0, 0.025)", // Default "rgba(0, 0, 0, 0.05)",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&": {
            borderRadius: "8px", // Default "4px"
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          "& .MuiFormLabel-asterisk": {
            color: ColorVariables.MediumCarmine,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          "&": {
            textTransform: "none",
          },
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          "&": {
            borderRadius: "8px 8px 0 0",
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&": {
            transition: "background .3s",
          },
          "&:not(&-head):hover .MuiTableCell-root": {
            background: ColorVariables.Snow,
          },
          "&.MuiTableRow-hover:hover": {
            background: ColorVariables.Snow,
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          "&": {
            borderBottomColor: ColorVariables.AntiFlashWhite2,
            transition: "background .3s",
            padding: "0.85rem",
          },
        },
        head: {
          "&": {
            background: ColorVariables.Snow,
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        action: {
          "&": {
            paddingTop: 0,
          },
        },
      },
    },
  },
});

export default GlobalTheme;
